import BlockUi from 'react-block-ui';
import Select from 'react-select';
import { Dropdown } from 'react-bootstrap';
import { customSelectStyle } from '../../../../_metronic/_partials/dropdowns/ReactSelectCustomStyle';
import DeleteItemModal from '../_modal/deleteItem';
import { useAddItemBootstrap } from './add-item.bootstrap.hook';

export default function AddJussubItems(props) {
  const itemId = props.match.params.item_id;
  const {
    loading,
    formik,
    displayValue,
    showDeleteModal,
    setShowDeleteModal,
    isDeleting,
    statusTypeOptions,
    benefitsTypeOptions,
    selectedStatusType,
    selectedBenefitsType,
    handleValueChange,
    handleValueFocus,
    handleValueBlur,
    handleDeleteItem,
    handleCancel,
    parseBoolean,
  } = useAddItemBootstrap(itemId);

  if (loading) {
    return <div>Carregando...</div>;
  }

  return (
    <BlockUi tag="div" blocking={formik.isSubmitting}>
      <div className="card card-custom mb-20">
        <div className="card-body add-item-form-card">
          <div className="add-item-form-card__header mb-8 d-flex justify-content-between align-items-center">
            <h4 className="add-item-form-card__title m-0">
              {itemId ? 'Editar produto' : 'Adicionar produto'}
            </h4>

            <div className="add-item-form-card__actions d-flex align-items-center">
              <button
                type="button"
                className="btn add-item-form-card__btn-cancel mr-2"
                onClick={handleCancel}
                disabled={formik.isSubmitting}
              >
                Cancelar
              </button>

              <button
                type="button"
                className="btn btn-primary add-item-form-card__btn-save"
                onClick={formik.handleSubmit}
                disabled={formik.isSubmitting}
              >
                Salvar produto
              </button>

              {itemId && (
                <Dropdown className="ml-2">
                  <Dropdown.Toggle
                    variant="light"
                    id={`items-options-${itemId}`}
                    className="btn-icon items-row-action add-item-form-card__dropdown-toggle"
                    aria-label={`Abrir opções do produto ${itemId}`}
                  >
                    <i className="ki ki-more-ver" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu alignRight>
                    <Dropdown.Item onClick={() => setShowDeleteModal(true)}>
                      <i
                        className="flaticon2-trash text-danger mr-3"
                        style={{ fontSize: '1.2rem' }}
                      />

                      <span className="text-danger mb-0 mt-1">
                        Excluir produto
                      </span>
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              )}
            </div>
          </div>

          <div className="row mb-6">
            <div className="col-12 col-md-6">
              <label htmlFor="name" className="add-item-form-card__label">
                Nome <span className="text-danger">*</span>
              </label>

              <input
                id="name"
                type="text"
                name="name"
                className={
                  'form-control ' +
                  (formik.errors.name && formik.touched.name
                    ? 'is-invalid'
                    : '')
                }
                value={formik.values.name || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              {formik.errors.name && formik.touched.name && (
                <div className="invalid-feedback">{formik.errors.name}</div>
              )}
            </div>

            <div className="col-12 col-md-6">
              <label htmlFor="code" className="add-item-form-card__label">
                Código do produto <span className="text-danger">*</span>
              </label>

              <input
                id="code"
                type="text"
                name="code"
                className={
                  'form-control ' +
                  (formik.errors.code && formik.touched.code
                    ? 'is-invalid'
                    : '')
                }
                value={formik.values.code || ''}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />

              {formik.errors.code && formik.touched.code && (
                <div className="invalid-feedback">
                  {formik.errors.code}
                </div>
              )}
            </div>

            <div className="col-12 col-md-6">
              <label className="add-item-form-card__label">
                Status <span className="text-danger">*</span>
              </label>

              <Select
                name="statusType"
                options={statusTypeOptions}
                styles={customSelectStyle}
                placeholder="Selecione..."
                value={selectedStatusType}
                onChange={(option) => {
                  formik.setFieldValue(
                    'statusType',
                    option ? option.value : '',
                  );
                  formik.setFieldTouched('statusType', true);
                }}
                onBlur={() => {
                  formik.setFieldTouched('statusType', true);
                }}
                className={
                  formik.errors.statusType && formik.touched.statusType
                    ? 'is-invalid'
                    : ''
                }
              />

              {formik.errors.statusType && formik.touched.statusType && (
                <div className="invalid-feedback d-block">
                  {formik.errors.statusType}
                </div>
              )}
            </div>
          </div>

          <div className="row">
            <div className="col-12 col-md-6 mb-6">
              <label htmlFor="value" className="add-item-form-card__label">
                Valor <span className="text-danger">*</span>
              </label>

              <input
                id="value"
                type="text"
                name="value"
                className={
                  'form-control ' +
                  (formik.errors.value && formik.touched.value
                    ? 'is-invalid'
                    : '')
                }
                value={displayValue}
                onChange={handleValueChange}
                onFocus={handleValueFocus}
                onBlur={handleValueBlur}
              />

              {formik.errors.value && formik.touched.value && (
                <div className="invalid-feedback">{formik.errors.value}</div>
              )}
            </div>

            <div className="col-12 col-md-6 mb-6">
              <label className="add-item-form-card__label">
                Tipo de benefício <span className="text-danger">*</span>
              </label>

              <Select
                name="benefitType"
                options={benefitsTypeOptions}
                styles={customSelectStyle}
                placeholder="Selecione..."
                value={selectedBenefitsType}
                onChange={(option) => {
                  formik.setFieldValue(
                    'benefitType',
                    option ? option.value : '',
                  );
                  formik.setFieldTouched('benefitType', true);
                }}
                onBlur={() => {
                  formik.setFieldTouched('benefitType', true);
                }}
                className={
                  formik.errors.benefitType && formik.touched.benefitType
                    ? 'is-invalid'
                    : ''
                }
              />

              {formik.errors.benefitType && formik.touched.benefitType && (
                <div className="invalid-feedback d-block">
                  {formik.errors.benefitType}
                </div>
              )}
            </div>

            <div className="col-12 col-md-6 mb-6">
              <div className="d-flex align-items-center">
                <span className="add-item-form-card__label mb-0 mr-3">
                  Visível para o cliente <span className="text-danger">*</span>
                </span>

                <label
                  htmlFor="display_client"
                  className="checkbox checkbox-lg checkbox-primary mb-0"
                >
                  <input
                    id="display_client"
                    type="checkbox"
                    name="display_client"
                    checked={parseBoolean(formik.values.display_client)}
                    onChange={(event) => {
                      formik.setFieldValue(
                        'display_client',
                        event.target.checked,
                      );
                    }}
                    onBlur={() => {
                      formik.setFieldTouched('display_client', true);
                    }}
                  />

                  <span />
                </label>
              </div>

              {formik.errors.display_client &&
                formik.touched.display_client && (
                  <div className="invalid-feedback d-block">
                    {formik.errors.display_client}
                  </div>
                )}
            </div>
          </div>
        </div>

        {showDeleteModal && (
          <DeleteItemModal
            onConfirm={handleDeleteItem}
            onClose={() => setShowDeleteModal(false)}
            isLoading={isDeleting}
          />
        )}
      </div>
    </BlockUi>
  );
}
